import type { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'

export const CommentsListSkeleton = (): ReactNode => (
  <div className="space-y-5 md:space-y-6" role="status" aria-label="Loading Comments">
    {Array.from({ length: 3 }).map((_, i) => (
      <div key={i} aria-hidden="true">
        <div className="flex w-full flex-row items-start gap-2.5 sm:gap-2.5">
          <Skeleton className="size-10 rounded-full" />

          <div className="relative w-[calc(100%-40px)] min-w-0 grow-0 rounded-xl">
            <div className="relative rounded-xl p-[15px]">
              <div className="mb-3 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Skeleton className="h-4 w-20 rounded-sm" />
                  <Skeleton className="h-3 w-16 rounded-sm" />
                </div>
              </div>

              <div className="space-y-2">
                <Skeleton className="h-4 w-full rounded-sm" />
                <Skeleton className="h-4 w-3/4 rounded-sm" />
                <Skeleton className="h-4 w-1/2 rounded-sm" />
              </div>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
)
